module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/sieve-ce440d90e5df82abeaf0d7c23a543236.svg";